import { useSelectors } from '@exodus/headless-react';
import { useSelector } from 'react-redux';
const useIsExchanging = () => {
    const selectors = useSelectors();
    const exchangeStatus = useSelector(selectors.exchange.status)?.status;
    return Boolean(exchangeStatus);
};
export default useIsExchanging;
